import { world } from '../..';
import { POI_ID, POI } from '../feature/navigator/navigator.model';

/**
 * Takes an ID and returns a POI Object from the world map
 * @param poi_ID
 * @returns POI
 */
export const getPOIFrom = (poi_ID: POI_ID): POI | undefined => {
  return world.find((poi) => poi.id === poi_ID);
};
